import { render, staticRenderFns } from "./upload_v2.vue?vue&type=template&id=6773fac6"
import script from "./upload_v2.vue?vue&type=script&lang=js"
export * from "./upload_v2.vue?vue&type=script&lang=js"
import style0 from "./upload_v2.vue?vue&type=style&index=0&id=6773fac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports